export default __webpack_public_path__ + "static/media/customer1.a921577e.svg";